<mat-card class="cur-card">
  <mat-card-header>
    <mat-card-title>入金消込</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="table-responsive" style="max-height: 1480px; ">
      <table mat-table [dataSource]="dataSource" matSort #sort1="matSort"
        style="width: 100%; border: solid 1px rgba(0, 0, 0, 0.12);">
        <ng-container matColumnDef="select">
          <th mat-header-cell class="border-bottom-double" *matHeaderCellDef style="width: 2em; min-width: 2em;">対象
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-radio-button color="primary" (change)="$event ? this.selection.toggle(row) : null;"
              [checked]="selection.isSelected(row)" name="keshikomi">
            </mat-radio-button>
          </td>
        </ng-container>
        <ng-container matColumnDef="payDlineYearmonthdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:105px;">
            支払期限年月日</th>
          <td mat-cell *matCellDef="let row">{{ row.payDlineYearmonthdate | dateString}}</td>
        </ng-container>
        <ng-container matColumnDef="claimYmd">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:80px;">
            請求年月日</th>
          <td mat-cell *matCellDef="let row">{{ row.claimYmd | dateString}}</td>
        </ng-container>
        <ng-container matColumnDef="chargeDiv">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:120px;">
            料金区分</th>
          <td mat-cell *matCellDef="let row">{{ row.chargeDiv }}</td>
        </ng-container>
        <ng-container matColumnDef="claimMethodCodeAname">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:70px;">
            請求区分</th>
          <td mat-cell *matCellDef="let row">{{ row.claimMethodCodeAname }}</td>
        </ng-container>
        <ng-container matColumnDef="claimSts">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:105px;">
            請求ステータス</th>
          <td mat-cell *matCellDef="let row">{{ row.claimSts }}</td>
        </ng-container>
        <ng-container matColumnDef="transferdateSalesreportdate">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:130px;">
            振替日／売上報告日</th>
          <td mat-cell *matCellDef="let row">{{ row.transferdateSalesreportdate | dateString}}</td>
        </ng-container>
        <ng-container matColumnDef="claimAmt">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:105px;">
            請求額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.claimAmt| number }}</td>
        </ng-container>
        <ng-container matColumnDef="nrcptMny">
          <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef style="min-width:105px;">
            未入金額[円]</th>
          <td mat-cell *matCellDef="let row" class="text-right">{{ row.nrcptMny| number }}</td>
        </ng-container>
        <ng-container matColumnDef="seikyuuryoukinBangou">
          <th mat-header-cell [style.display]="'none'" class="border-bottom-double" *matHeaderCellDef
            style="min-width:80px;"></th>
          <td mat-cell [style.display]="'none'" *matCellDef="let row">{{ row.claimChargeNo }}</td>
        </ng-container>
        <ng-container matColumnDef="minyuukinSrno">
          <th mat-header-cell [style.display]="'none'" class="border-bottom-double" *matHeaderCellDef
            style="min-width:80px;"></th>
          <td mat-cell [style.display]="'none'" *matCellDef="let row">{{ row.nrcptUpdateSrno }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
        <tr id="minyuukinList" mat-row *matRowDef="let row; columns: displayedColumnsCol"></tr>
      </table>
    </div>
    <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>
    <ng-template #extension_point></ng-template>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
      <mat-card-actions class="btn_area_right">
        <button type="button" [disabled]="selection.selected.length <= 0" mat-raised-button color="primary"
          (click)="onRegist()" class="btn">登録</button>
      </mat-card-actions>
    </div>
  </mat-card-content>
</mat-card>